import React from 'react';
import { Box } from '@mui/material';
import { DotLoader } from 'react-spinners';

const Loader = () => {
  return (
    <Box
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 1300,
      }}
    >
      <DotLoader color="#75ad3e" size={50} />{' '}
    </Box>
  );
};

export default Loader;
